import { useClarityIdentity } from "../../clarity";
import { useCookieConsent } from "../../helpers/useCookieConsent";

export const ClarityInitializer = () => {
  useCookieConsent();
  useClarityIdentity();

  return null;
};
